import { useCallback } from "react"
import { FormStateProps } from "../interface/components"
import { Option } from "../interface/components"

export const options = [
    {
        team: 'GO',
        unit: [
            'Jataí',
            'Mineiros',
            'Caiapônia',
            'Uruaçu'
        ],
        id_unit: [
            16939,
            17104,
            17105,
            19480
        ]
    },
    {
        team: 'MT',
        unit: [
            'Alto Taquari'
        ],
        id_unit: [
            17106
        ]
    }
]

export const typeOptions = [
    {
        label: "Implementos",
        value: 107017
    },
    {
        label: "Máquinas Agrícolas",
        value: 107016
    },
    {
        label: "Peças",
        value: 107018
    },
    {
        label: "Serviços",
        value: 107019
    }
]


export const validate = (value: any, type: 'name' | 'select' | 'email' | 'phone'): any => {
    if (type === 'name') {
        const splitName = value.trim().split(' ')
        const nameValid = splitName.length >= 2 && splitName.every((part: string) => part !== '')

        return nameValid
    }
    
    if (type === 'select') return value ? true : false

    if (type === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
        const emailValid = emailRegex.test(value)

        return emailValid
    }
    
    if (type === 'phone') {
        let newCell = value.replace(/\D/g, "") // Remove tudo exceto números

        if (newCell.length > 11) { // Se mais de 11 números, truncar.
            newCell = newCell.substring(0, 11)
        }

        // Formatação
        if (newCell.length === 0) {
            // não fazer nada, mantenha o valor vazio
        } else if (newCell.length <= 2) {
            newCell = newCell.replace(/^(\d{0,2})/, "($1")
        } else if (newCell.length <= 7) {
            newCell = newCell.replace(/^(\d{0,2})(\d{0,5})/, "($1) $2")
        } else {
            newCell = newCell.replace(/^(\d{0,2})(\d{0,5})(\d{0,4})/, "($1) $2-$3")
        }

        const phoneValid = newCell.length === 15 || !newCell

        return { phone: newCell, isValid: phoneValid }
    }
}

export const useHandleFullNameChange = () => {
    return useCallback((event: React.ChangeEvent<HTMLInputElement>, setState: React.Dispatch<React.SetStateAction<FormStateProps>>) => {
        const fullName = event.target.value
        setState((prevState: FormStateProps) => ({
            ...prevState,
            fullName,
            isFullNameValid: validate(fullName, 'name')
        }))
    }, [])
}

export const useHandleEmailChange = () => {
    return useCallback((event: React.ChangeEvent<HTMLInputElement>, setState: React.Dispatch<React.SetStateAction<FormStateProps>>) => {
        const email = event.target.value
        setState((prevState: FormStateProps) => ({
            ...prevState,
            email,
            isEmailValid: validate(email, 'email')
        }))
    }, [])
}

export const useHandleCellPhoneChange = () => {
    return useCallback((event: React.ChangeEvent<HTMLInputElement>, setState: React.Dispatch<React.SetStateAction<FormStateProps>>) => {
        const phone = event.target.value
        setState((prevState: FormStateProps) => ({
            ...prevState,
            phone: validate(phone, 'phone').phone,
            isPhoneValid: validate(phone, 'phone').isValid
        }))
    }, [])
}
export const useHandleTypeChange = () => {
    return useCallback((value: any, setState: React.Dispatch<React.SetStateAction<FormStateProps>>) => {
        const selectedType = value
        setState((prevState: FormStateProps) => ({
            ...prevState,
            selectedType,
            isSelectedTypeValid: validate(selectedType, 'select'),
        }))
    }, [])
}

export const useHandleSelectedTeamChange = () => {
    return useCallback((value: any, setState: React.Dispatch<React.SetStateAction<FormStateProps>>) => {
        const selectedTeam = value
        const teamOption: Option = options.find(opt => opt.team === value) || { team: '', unit: [], id_unit: [] }
        setState((prevState: FormStateProps) => ({
            ...prevState,
            selectedTeam,
            isSelectedTeamValid: validate(selectedTeam, 'select'),
            unitOptions: { labels: teamOption.unit, values: teamOption.id_unit }
        }))
    }, [])
}

export const useHandleSelectedUnitChange = () => {
    return useCallback((value: any, setState: React.Dispatch<React.SetStateAction<FormStateProps>>) => {
        const selectedUnit = value
        setState((prevState: FormStateProps) => ({
            ...prevState,
            selectedUnit,
            isSelectedUnitValid: validate(selectedUnit, 'select')
        }))
    }, [])
}
